import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { filter, map, pairwise, startWith } from 'rxjs';
import { TopNavFilterConfig } from '../../../core/model/common';
import { AccountState } from '../../../core/services/states/account.service';
import { ClientState } from '../../../core/services/states/client.service';
import { FarmState } from '../../../core/services/states/farm.service';
import { TopNavState } from '../../../core/services/states/topnav.service';

@Component({
  selector: 'header-client',
  template: `
    <nz-select
      class="top-nav-select"
      [ngModel]="(clientState.get$() | async)?.clientId"
      (ngModelChange)="onChange($event)"
      style="opacity: 0.9; width: 200px;"
      [hidden]="!showClientSelector"
    >
      @for (item of clientState.getClientList$() | async; track $index) {
        <nz-option [nzValue]="item.clientId" [nzLabel]="item.clientName"></nz-option>
      } @empty {}
    </nz-select>
  `,
  host: {
    '[class.flex-1]': 'true'
  },
  imports: [NzIconModule, NzSelectModule, FormsModule, AsyncPipe]
})
export class HeaderClientComponent implements OnInit {
  protected router = inject(Router);
  protected destroyRef = inject(DestroyRef);
  protected clientState = inject(ClientState);
  protected farmState = inject(FarmState);
  protected topNavState = inject(TopNavState);
  protected accountState = inject(AccountState);
  protected showClientSelector: boolean = true;
  systemAllowedPaths: string[] = ['/userSettings/role', '/userSettings/account'];
  constructor(private changeDetector: ChangeDetectorRef) {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(event => event.urlAfterRedirects),
        startWith(this.router.url),
        pairwise(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(([beforeUrl, afterUrl]) => {
        const beforeInTargets = this.systemAllowedPaths.some(path => beforeUrl.includes(path));
        const afterInTargets = this.systemAllowedPaths.some(path => afterUrl.includes(path));

        if ((!beforeInTargets && afterInTargets) || (beforeInTargets && !afterInTargets)) {
          this.clientState.initClientList();
          this.farmState.initFarmList();
        }
      });
  }
  ngOnInit(): void {
    this.clientState.initClientList();

    if (!this.accountState.isAdmin()) {
      this.showClientSelector = false;
    }

    this.topNavState.topNav$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((config: TopNavFilterConfig) => config.showClientSelector)
      )
      .subscribe((showClientSelector: boolean) => {
        if (this.showClientSelector != showClientSelector && this.accountState.isAdmin()) {
          this.showClientSelector = showClientSelector;
          this.changeDetector.detectChanges();
        }
      });
  }

  onChange(clientId: number) {
    const selectedClient = this.clientState.getClientList().find(client => client.clientId === clientId);
    if (selectedClient) {
      this.clientState.setState(selectedClient);
      this.farmState.initFarmList();
    }
  }
}
